import React from "react"
import { FaLinkedin, FaInstagram, FaGithub } from "react-icons/fa"

export default [
  {
    icon: <FaGithub />,
    url: "https://github.com/SohaibArbiBakcha",
  },
  {
    icon: <FaLinkedin />,
    url: "https://www.linkedin.com/in/sohaibarbibakcha",
  },
  {
    icon: <FaInstagram />,
    url: "https://www.instagram.com/sohaib.arbi/",
  },
]
